
export function handleCategoryDropdown($ : JQueryStatic = jQuery)
{
    $('#cat').change(function() {
        let $selectedValue = $(this).children("option:selected").val();

        if( $selectedValue !== '' ){
            window.location.href = '/news/category/' + $selectedValue;
        }
    });
}

